import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase';

function FixtureGoals({fixtureId, fixture}) {

    const [goals, setGoals] = useState([]);

    useEffect(() => {

        try {
            const goalsRef = firestore.collection("fixtures").doc(fixtureId).collection("goals");
            goalsRef.onSnapshot(({docs}) => {
                const goals = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setGoals(goals)
            })
        } catch (error) {
            
        }

    }, [fixtureId])

    return (
        <div>
            {goals?.map((goal, index) => {
                return (
                    <div className="col-12" key={index} style={{fontSize: "0.8rem"}}>
                        <div className="row">
                            <div className="col-5">
                                <div className="float-right">
                                    {goal.team_scored === "home" && goal.goalscorer}
                                </div>
                            </div>
                            <div className="col-2 text-center">
                                {goal.score}
                            </div>
                            <div className="col-5">
                                {goal.team_scored === "away" && goal.goalscorer}
                            </div>
                        </div>
                    </div> 
                )
            })}
        </div>
    )
}
export default FixtureGoals